import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { FaGooglePlay, FaInfoCircle, FaComments, FaListOl, FaUserAstronaut, FaCommentDots, FaShieldAlt, FaClock, FaStarAndCrescent } from "react-icons/fa";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Manubar from "./Manubar";

const Astrologer = () => {
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.ratnavali.app";
  
  const handleDownloadClick = () => {
    window.open(playStoreLink, '_blank');
    toast.success("Redirecting to Google Play Store!");
  };

  // CSS Styles - Simplified
  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#fff"
    },
    card: {
      border: "none",
      borderRadius: "12px",
      overflow: "hidden"
    },
    cardHeader: {
      backgroundColor: "#160015",
      border: "none",
      color: "#160015"
    },
    appIconCircle: {
      width: "100px",
      height: "100px",
      margin: "0 auto",
      borderRadius: "50%",
      backgroundColor: "#160015",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "3px solid #160015"
    },
    stepNumber: {
      width: "32px",
      height: "32px",
      flexShrink: 0,
      fontSize: "14px",
      fontWeight: "bold",
      backgroundColor: "#160015",
      color: "#fee894",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    downloadBtn: {
      backgroundColor: "#160015",
      color: "#fee894",
      border: "2px solid #160015",
      padding: "12px 30px",
      fontSize: "16px",
      fontWeight: "600",
      borderRadius: "8px",
      transition: "all 0.3s ease",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center"
    },
    downloadBtnHover: {
      backgroundColor: "#160015",
      color: "#160015",
      borderColor: "#160015"
    },
    featureCard: {
      border: "2px solid #f0f0f0",
      borderRadius: "10px",
      transition: "all 0.3s ease",
      height: "100%",
      backgroundColor: "#fff",
      padding: "20px 15px"
    },
    featureCardHover: {
      borderColor: "#160015",
      backgroundColor: "#fef9e7"
    },
    alertBox: {
      backgroundColor: "#fef9e7",
      border: "2px solid #160015",
      borderRadius: "10px",
      color: "#160015"
    }
  };

  return (
    <div style={styles.container}>
      <ToastContainer position="top-center" />

      {/* Modal for Mobile Menu */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />
        <Navbar />
      </header>

      <section className="categories py-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-12">
              <div className="card" style={styles.card}>
                <div className="card-header text-center py-3" style={styles.cardHeader}>
                  <h2 className="mb-0 fw-bold" style={{ color: "#fee894" }}>
                    <FaComments style={{ marginRight: "10px" }} />
                    Chat with Astrologers
                  </h2>
                </div>
                
                <div className="card-body p-4 p-md-5">
                  {/* App Icon/Logo */}
                  <div className="text-center mb-4">
                    
                    <h3 className="text-dark fw-bold mb-2">Ratnavali App</h3>
                  </div>

                  {/* Important Notice */}
                  <div className="p-3 mb-4" style={styles.alertBox}>
                    <div className="d-flex align-items-start">
                      <div className="me-3">
                        <FaInfoCircle style={{ fontSize: "1.2rem", color: "#160015" }} />
                      </div>
                      <div>
                        <h6 className="fw-bold mb-2" style={{ color: "#160015" }}>Important Notice!</h6>
                        <p className="mb-0 small">
                          To chat with astrologers, you need to download our official Ratnavali app.
                          In the app, you can directly talk with astrology experts and get personalized guidance.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Step-by-Step Instructions */}
                  <div className="mb-4">
                    <h5 className="mb-3 text-dark fw-bold">
                      <FaListOl style={{ marginRight: "10px", color: "#160015" }} />
                      Simple Steps to Get Started:
                    </h5>
                    <div className="steps-container">
                      <div className="step-item d-flex mb-3">
                        <div style={styles.stepNumber} className="me-3">
                          1
                        </div>
                        <div className="step-content">
                          <h6 className="mb-1 fw-bold">Go to Google Play Store</h6>
                          <p className="text-muted mb-0 small">Or click the button below</p>
                        </div>
                      </div>
                      
                      <div className="step-item d-flex mb-3">
                        <div style={styles.stepNumber} className="me-3">
                          2
                        </div>
                        <div className="step-content">
                          <h6 className="mb-1 fw-bold">Search for "Ratnavali App"</h6>
                          <p className="text-muted mb-0 small">Or use the direct link provided</p>
                        </div>
                      </div>
                      
                      <div className="step-item d-flex mb-3">
                        <div style={styles.stepNumber} className="me-3">
                          3
                        </div>
                        <div className="step-content">
                          <h6 className="mb-1 fw-bold">Tap the Install Button</h6>
                          <p className="text-muted mb-0 small">The app will install on your device</p>
                        </div>
                      </div>
                      
                      <div className="step-item d-flex">
                        <div style={styles.stepNumber} className="me-3">
                          4
                        </div>
                        <div className="step-content">
                          <h6 className="mb-1 fw-bold">Start Chatting with Astrologers</h6>
                          <p className="text-muted mb-0 small">Open the app and connect with astrology experts</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Download Button */}
                  <div className="text-center mt-4">
                    <button 
                      onClick={handleDownloadClick}
                      style={styles.downloadBtn}
                      className="download-btn"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = styles.downloadBtnHover.backgroundColor;
                        e.currentTarget.style.color = styles.downloadBtnHover.color;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = styles.downloadBtn.backgroundColor;
                        e.currentTarget.style.color = styles.downloadBtn.color;
                      }}
                    >
                      <FaGooglePlay style={{ marginRight: "10px", fontSize: "1.2rem" }} />
                      Download from Google Play
                    </button>
                    
                    
                  </div>

                  {/* App Features */}
                  <div className="row mt-4 pt-4 border-top">
                    <div className="col-md-6 mb-3">
                      <div 
                        className="text-center h-100" 
                        style={styles.featureCard}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = styles.featureCardHover.borderColor;
                          e.currentTarget.style.backgroundColor = styles.featureCardHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#f0f0f0";
                          e.currentTarget.style.backgroundColor = "#fff";
                        }}
                      >
                        <div className="mb-3">
                          <FaUserAstronaut style={{ fontSize: "1.8rem", color: "#160015" }} />
                        </div>
                        <h6 className="fw-bold">Certified Astrologers</h6>
                        <p className="text-muted small mb-0">
                          Verified and experienced astrology experts
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div 
                        className="text-center h-100" 
                        style={styles.featureCard}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = styles.featureCardHover.borderColor;
                          e.currentTarget.style.backgroundColor = styles.featureCardHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#f0f0f0";
                          e.currentTarget.style.backgroundColor = "#fff";
                        }}
                      >
                        <div className="mb-3">
                          <FaCommentDots style={{ fontSize: "1.8rem", color: "#160015" }} />
                        </div>
                        <h6 className="fw-bold">Live Chat</h6>
                        <p className="text-muted small mb-0">
                          Ask questions in real-time conversations
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div 
                        className="text-center h-100" 
                        style={styles.featureCard}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = styles.featureCardHover.borderColor;
                          e.currentTarget.style.backgroundColor = styles.featureCardHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#f0f0f0";
                          e.currentTarget.style.backgroundColor = "#fff";
                        }}
                      >
                        <div className="mb-3">
                          <FaShieldAlt style={{ fontSize: "1.8rem", color: "#160015" }} />
                        </div>
                        <h6 className="fw-bold">Secure & Private</h6>
                        <p className="text-muted small mb-0">
                          Your conversations are completely confidential
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div 
                        className="text-center h-100" 
                        style={styles.featureCard}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = styles.featureCardHover.borderColor;
                          e.currentTarget.style.backgroundColor = styles.featureCardHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#f0f0f0";
                          e.currentTarget.style.backgroundColor = "#fff";
                        }}
                      >
                        <div className="mb-3">
                          <FaClock style={{ fontSize: "1.8rem", color: "#160015" }} />
                        </div>
                        <h6 className="fw-bold">24/7 Availability</h6>
                        <p className="text-muted small mb-0">
                          Connect with astrologers anytime, anywhere
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                
              </div>
            </div>
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default Astrologer;